document.addEventListener("shopify:section:load", initVideos);
document.addEventListener("DOMContentLoaded", initVideos);

function initVideos() {
  const deferredMedia = document.querySelectorAll("deferred-media");

  deferredMedia.forEach((media) => {
    const template = media.querySelector("template");

    if (template) {
      const content = template.content.cloneNode(true);
      // Strip autoplay and poster before the video enters the page, otherwise both download straight away
      content.querySelectorAll("video").forEach((video) => {
        video.removeAttribute("autoplay");
        if (video.getAttribute("poster")) {
          video.dataset.poster = video.getAttribute("poster");
          video.removeAttribute("poster");
        }
      });
      media.appendChild(content);
      template.remove();
    }

    // Videos loop silently, but only download and play once on screen (initProductVideos in theme.liquid)
    const video = media.querySelector("video");
    if (video) {
      video.muted = true;
      video.loop = true;
      video.classList.add("js-lazy-play");
    }

    const poster = media.querySelector(".deferred-media__poster");
    if (poster) poster.style.display = "none";
  });

  if (typeof initProductVideos === "function") initProductVideos();
}


/* Phone country picker (intl-tel-input) for the signup forms' mobile field.
   Until 31/10/2026 it loaded from jsdelivr on every page and built a 244-country list into each page.
   Now it loads only when a signup form comes near the screen or someone starts using one.
   Same library version and settings as before. */
(function () {
  var base = "https://cdn.jsdelivr.net/npm/intl-tel-input@19.5.6/build/";
  var loading = null;

  function loadLibrary() {
    if (window.intlTelInput) return Promise.resolve();
    if (loading) return loading;
    loading = new Promise(function (resolve, reject) {
      var css = document.createElement("link");
      css.rel = "stylesheet";
      css.href = base + "css/intlTelInput.css";
      document.head.appendChild(css);
      var script = document.createElement("script");
      script.src = base + "js/intlTelInput.min.js";
      script.async = true;
      script.onload = resolve;
      script.onerror = function () { loading = null; reject(); };
      document.head.appendChild(script);
    });
    return loading;
  }

  function setUpPhone(input) {
    if (!input || input.dataset.itiState) return;
    input.dataset.itiState = "loading";
    loadLibrary().then(function () {
      var hadFocus = document.activeElement === input;
      window.intlTelInput(input, {
        initialCountry: "au",
        separateDialCode: true,
        preferredCountries: ["au", "in", "us", "gb"]
      });
      input.dataset.itiState = "ready";
      // The picker wraps the field, which can drop focus if the shopper was already in it
      if (hadFocus && document.activeElement !== input) input.focus();
    }).catch(function () { delete input.dataset.itiState; });
  }

  function phoneIn(target) {
    var form = target && target.closest ? target.closest("form") : null;
    return form ? form.querySelector('[id^="NewsletterPhone--"]') : null;
  }

  function onFormInteraction(event) {
    var input = phoneIn(event.target);
    if (input) setUpPhone(input);
  }

  function watchForms() {
    var inputs = document.querySelectorAll('[id^="NewsletterPhone--"]');
    if (!inputs.length) return;
    if (!("IntersectionObserver" in window)) return;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        setUpPhone(entry.target.querySelector('[id^="NewsletterPhone--"]'));
      });
    }, { rootMargin: "300px 0px" });
    inputs.forEach(function (input) {
      var form = input.closest("form");
      if (form) observer.observe(form);
    });
  }

  document.addEventListener("focusin", onFormInteraction);
  document.addEventListener("pointerdown", onFormInteraction, { passive: true });
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", watchForms);
  } else {
    watchForms();
  }
})();





document.querySelectorAll('.accordion__inner').forEach((accordion) => {
    accordion.addEventListener('toggle', function () {
        const icon = this.querySelector('.accordion-icon');
        if (!icon) return; // some drawers have no +/− icon (31/10/2026)

        if (this.open) {
            icon.textContent = '−';
        } else {
            icon.textContent = '+';
        }
    });
});


window.addEventListener('load', function () {
  document.querySelectorAll('.main-product__media-badge').forEach(function (el) {
    if (el.textContent.trim().toLowerCase() === 'made to order') {
      el.classList.add('made-to-order');
    }
  });
});

/* MJ 2048-variant support (added Oct 2026).
   Mojave's product-selector only knows the first 250 variants of a product.
   When a chosen combination isn't among them, this looks it up through the
   Section Rendering API in ONE request (main product section + the
   sections/mj-variant-lookup.liquid helper) and shows a loading state,
   not "Unavailable", while it waits. */
customElements.whenDefined('product-selector').then(function () {
  var Selector = customElements.get('product-selector');
  if (!Selector || Selector.prototype.__mjVariantFix) return;
  Selector.prototype.__mjVariantFix = true;

  var proto = Selector.prototype;
  var originalUpdateMasterId = proto.updateMasterId;
  var originalToggleAddButton = proto.toggleAddButton;
  var originalSetUnavailable = proto.setUnavailable;

  function unavailableText() {
    return window.theme && window.theme.strings && window.theme.strings.product.unavailable;
  }

  proto.mjIsLarge = function () {
    try { return this.getVariantData().length >= 250; } catch (e) { return false; }
  };

  // Option value name -> ID map, fetched once per page (in the background on load).
  proto.mjLoadOptionIds = function () {
    var self = this;
    if (!this.mjOptionIdsPromise) {
      this.mjOptionIdsPromise = fetch(this.dataset.url + '?section_id=mj-variant-lookup')
        .then(function (r) { return r.text(); })
        .then(function (t) {
          var el = new DOMParser().parseFromString(t, 'text/html').querySelector('[data-mj-option-ids]');
          return el ? JSON.parse(el.textContent) : null;
        })
        .catch(function () { self.mjOptionIdsPromise = null; return null; });
    }
    return this.mjOptionIdsPromise;
  };

  proto.updateMasterId = function () {
    this.mjToken = (this.mjToken || 0) + 1;
    this.mjPending = false;
    originalUpdateMasterId.call(this);
    if (!this.currentVariant && this.mjIsLarge()) {
      this.mjPending = true;
      this.mjLookupVariant(this.mjToken);
    }
  };

  // While a lookup is running, show the loading spinner instead of "Unavailable".
  proto.toggleAddButton = function (disable, text) {
    if (this.mjPending && text === unavailableText()) {
      return originalToggleAddButton.call(this, true, '');
    }
    return originalToggleAddButton.call(this, disable, text);
  };

  proto.setUnavailable = function () {
    if (this.mjPending) return;
    return originalSetUnavailable.call(this);
  };

  proto.mjFail = function (token) {
    if (token !== this.mjToken) return;
    this.mjPending = false;
    originalToggleAddButton.call(this, true, unavailableText());
    originalSetUnavailable.call(this);
  };

  proto.mjLookupVariant = function (token) {
    var self = this;
    var options = (this.options || []).slice();
    var section = this.dataset.section;

    this.mjLoadOptionIds()
      .then(function (map) {
        if (!map) return null;
        var ids = [];
        for (var i = 0; i < map.length; i++) {
          if (map[i][options[i]] === undefined) return null;
          ids.push(map[i][options[i]]);
        }
        return fetch(
          self.dataset.url + '?option_values=' + ids.join(',') +
          '&sections=' + encodeURIComponent(section + ',mj-variant-lookup')
        ).then(function (r) { return r.json(); });
      })
      .then(function (sections) {
        if (token !== self.mjToken) return;
        if (!sections || !sections['mj-variant-lookup']) return self.mjFail(token);

        var parser = new DOMParser();
        var lookup = parser.parseFromString(sections['mj-variant-lookup'], 'text/html');
        var el = lookup.querySelector('[data-mj-variant]');
        var variant = el ? JSON.parse(el.textContent) : null;
        if (!variant || !variant.options) return self.mjFail(token);
        for (var i = 0; i < variant.options.length; i++) {
          if (variant.options[i] !== options[i]) return self.mjFail(token);
        }

        self.mjPending = false;
        self.currentVariant = variant;
        var main = sections[section] ? parser.parseFromString(sections[section], 'text/html') : null;

        var steps = [
          function () { self.updatePickupAvailability(); },
          function () { self.updateMedia(); },
          function () { if (!self.closest('modal-dialog')) self.updateURL(); },
          function () { self.updateVariantInput(); },
          function () { self.updateSellingPlanId(''); },
          function () { self.updateSKU(); },
          function () {
            if (main) {
              // Same result as updateProductInfo(), without a second request.
              self.changeProductPrice(main);
              self.updateInventoryNotice(main);
              originalToggleAddButton.call(self, !variant.available, window.theme.strings.product.soldOut);
            } else {
              self.updateProductInfo();
            }
          }
        ];
        steps.forEach(function (step) { try { step(); } catch (e) {} });
      })
      .catch(function () { self.mjFail(token); });
  };

  // Warm the option ID map as soon as a large product page loads.
  document.querySelectorAll('product-selector').forEach(function (el) {
    if (el.mjIsLarge && el.mjIsLarge()) el.mjLoadOptionIds();
  });
});
